export default __webpack_public_path__ + "static/media/750x750 kitten.48f4be07.jpg";